import { useSelector } from 'react-redux';
import FormField from '../../../ui/formField';
const USAddress = (props) => {
  const pageData = useSelector((state) => state.foreignResidencyData);
  const { loading, error, formData } = pageData;

  const onChangeHandler = (e) => {
    props.setUSAddress((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const label = formData?.data?.usAddresssLabel;
  const field = formData?.data?.usAddress.map((item, index) => {
    return (
      <FormField
        key={index}
        id={item.id}
        name={item.name}
        value={item.value}
        type={item.type}
        label={item.label}
        layoutType={item.layoutType}
        dropdownType={item.dropdownType}
        onChangeHandler={onChangeHandler}
      />
    );
  });
  return (
    <>
      {label && <h3>{label}</h3>}
      <div className="flex">{field}</div>
    </>
  );
};
export default USAddress;
